<template>
    <div>
        <h1>
            <strong>*</strong>题干
        </h1>
        <div class=" editorShowArea ql-editor" v-if="!isShowC" @click="editor_toggle_questionContent()" v-html="currentValue.questionContent"></div>
        <v-editor v-else v-model="currentValue.questionContent"></v-editor>
        <v-addFile :isUploading="isUploading" @changeUploadStatus="changeUploadStatus" v-model="currentValue.attachmentList"></v-addFile>
    </div>
</template>

<script>
import vEditor from "@/components/wjlEditor/index.vue";
import vAddFile from "../../../v_addFile";

export default {
    name: "addTestPracticalTest",
    components: {
        vEditor,
        vAddFile
    },
    props: {
        propName: { type: String },
        value: {
            type: Object,
            default: () => {}
        },
        isUploading: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            currentValue: {},
            isShowC: false,
        };
    },
    watch: {
        value: {
            handler(val) {
                if (Object.keys(val).length != 0) {
                    this.currentValue = val;
                } else {
                    // 实操题
                    this.currentValue = {
                        internalTypeId: 9, // 内部题型
                        questionTypeId: '', // 外部题型
                        questionContent: "", // 题干
                        items: [],
                        questionAnswer: "", // 答案
                        questionAnalysis: "", // 解析
                        subjectId: "", // 科目id
                        score: "", // 分数
                        difficulty: "", // 难度
                        labelIds: [], // 标签
                        materialIds: [], // 知识点
                        attachmentList: [],   // 附件id数组
                        parentId: 0,
                    };
                    this.isShowC = false
                }
            },
            immediate: true,
            deep: true
        },
        currentValue: {
            handler(val) {
                this.$emit("input", val);
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        // 题干editor显隐
        editor_toggle_questionContent() {
            this.isShowA = false;
            this.isShowC = true;
        },
        changeUploadStatus(str) {
            this.$emit('changeUploadStatus',str);
        }
    }
};
</script>

<style scoped lang="scss">
h1 {
    margin: 10px 0px;
    font-size: 15px;
    strong {
        color: red;
        margin-right: 5px;
    }
}
.editorShowArea {
    border: 1px solid #e2e2e2;
    background-color: #FFFFFF;
    min-height: 50px;
    // max-height: 100px;
    overflow: auto;
    padding: 5px;
}
.mb_10 {
    margin-bottom: 10px;
}
.resourceBtns button {
    border: 1px solid #5397f7;
    color: #5397f7;
}
/deep/ .el-input-group__prepend {
    background-color: #fff;
    color: #000000;
    font-weight: bold;
}
/deep/ .el-input-group__append {
    background-color: #5397f7;
}
/deep/ .el-icon-delete {
    color: #fff;
    cursor: pointer;
    &:hover {
        color: #000000;
    }
}
/deep/ .el-radio-button:first-child .el-radio-button__inner,
/deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 4px;
}
/deep/ .el-radio-button__inner {
    border-radius: 4px;
    border-left: 1px solid #dcdfe6;
}
/deep/ .el-radio-button {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/course/components/addTestPracticalTest.vue